module.exports = __webpack_public_path__ + "static/media/alert_icon.dbf31abd.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/icons/alert_icon.png
// module id = 135
// module chunks = 2